<template>
  <div class="swiper-tab">
    <div
      v-if="list.length"
      v-swiper-products-listings="activeTab"
      class="swiper-container swiper-container--product-listings-tabs">
      <div 
        v-lazy-container="{ selector: 'img' }"
        class="swiper-wrapper">
        <!-- Slides -->
        <div
          class="swiper-slide"
          v-for="(slide, index) of list"
          :key="index">
          <router-link :to="{ name: `${lang}.single-product`, params: { slug: slide.fields.slug } }">
            <img
              v-if="typeof slide.fields.productThumbnail !== 'undefined'"
              :data-src="slide.fields.productThumbnail.fields.file.url"
              :data-loading="lazyLoading"
              :alt="slide.fields.productThumbnail.fields.description"
              :width="slide.fields.productThumbnail.fields.file.details.image.width"
              :height="slide.fields.productThumbnail.fields.file.details.image.height"
              class="swiper-container--product-listings-tabs__img">
            <p v-html="slide.fields.title"/>
            <span v-if="typeof slide.fields.productCode !== 'undefined'" v-html="slide.fields.productCode" />
            <SingleProductListHasTags :product="slide" />
          </router-link>
        </div>
        <!-- Fine Slides -->
      </div>
      <!-- Operations -->
      <div class="swiper-operations">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import swiper from './swiper'
import SingleProductListHasTags from '@/components/SingleProductListHasTags/SingleProductListHasTags.vue'

export default {
  name: 'SwiperTab',
  components: {
    SingleProductListHasTags
  },
  mixins: [swiper],
  data: () => ({
    loading: true,
    lazyLoading: require('@/assets/lazy/tag-category-product.png')
  }),
  props: {
    list: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ]),
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>
